import React from 'react';
import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IAnimDurationFeature } from './anim-duration-interface';
import { config } from './config';
import AnimSelector from '@src/framework/frame-pc/components/anim-selector';
import { AnimType } from '@tencent/slide-sdk-model';
import { PPTEditorStateEnumType } from '@src/slide/domain/ui-model/constant/edit-state-type';


@Feature()
export class AnimDurationFeature extends BaseToolbarFeature implements IAnimDurationFeature {
    public id = config.id;
    public config = config;
    private selectedAnimList = this.getSelectedAnimManager()?.selectedArray;
    public constructor() {
        super();
    }

    public getDropdownContent() {
        return (
            <AnimSelector
                selectionService={this.getSelectionService()}
                selectedAnimList={this.getSelectedAnimManager()?.selectedArray}
                type="duration"
            />
        );
    }

    public shouldDisabled(): boolean {
        if (this.getUserPriviledgeService().pptEditorState !== PPTEditorStateEnumType.EDITABLE) return true;
        // 入场-出现，退场-消失动画，不支持设置持续时间
        const noDurationList = [AnimType.Appear, AnimType.Disappear];
        const noDur = this.selectedAnimList?.some(animModel => noDurationList.includes(animModel.props.animType));
        return !this.selectedAnimList?.length || !!noDur;
    }
}
